import Axios from 'axios'
import QueryString from 'querystring'
import URL from 'url-parse'
import URLSearchParams from 'url-search-params'
import _ from 'lodash'

export default class Api {
  constructor () {
    this.axios = Axios.create({
      timeout: 30000,
      withCredentials: true,
      validateStatus (status) {
        if (status >= 200 && status < 300) return true
        return status
      }
    })
  }

  handleResponse (response) {
    this.debug(response, 'Response')
    if (response.status >= 200 && response.status < 300) {
      return response
    }
    this.debug(response, 'ERROR!')
    let error = {
      internal: true,
      status: response.status,
      text: response.statusText,
      error: response.data
    }
    this.debug(error, 'ERROR!')
    throw error
  }

  debug (value, what = '') {
    if (process.env.NODE_ENV === 'development') {
      let timestamp = new Date()
      console.info(timestamp + '--- API: ' + what)
      console.info(value)
    }
  }

  getUrl (route, payload = {}) {
    if (!_.isEmpty(payload) && !_.isObject(payload)) {
      route = route + '/' + payload.toString()
    }
    const url = new URL(route, process.env.VUE_APP_LANG_URL)
    try {
      if (_.isObject(payload)) {
        const queryString = new URLSearchParams(QueryString.stringify(payload))
        url.search = queryString.toString()
      }
      return url.href
    } catch (error) {
      console.error(error)
    }
  }

  async request (method, path, payload = {}) {
    let options = {
      method: method,
      crossDomain: true,
      url: (method === 'get') ? await this.getUrl(path, payload) : this.getUrl(path),
      data: (method !== 'get') ? payload : {}
    }
    let response = await this.axios.request(options)
    return Promise.resolve(this.handleResponse(response))
  }

  async get (path, payload = {}) {
    try {
      const response = await this.request('get', path, payload)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async post (path, payload = {}) {
    return Promise.resolve(
      this.request('post', path, payload)
    )
  }

  async delete (path, payload = {}) {
    return Promise.resolve(
      this.request('delete', path, payload)
    )
  }
}
